<template>
  <OpportunitiesFeed v-if="data" v-bind="{ getFirstPage, getNextPage }">
    <template #header>
      <slot name="header">
        <LayoutFeedHeader>{{ termName }}</LayoutFeedHeader>
      </slot>
    </template>
  </OpportunitiesFeed>
</template>

<script lang="ts" setup>
import type { Term } from "~/@types/term"
import { groqTermFeed } from "~/groq/term"

const props = defineProps<{
  type: string
  slug: string
  name: string
}>()

const { type, slug, name } = toRefs(props)
const { getTermBySlug, getFirstPage, getNextPage } = groqTermFeed(
  type.value,
  slug.value,
)

const { data } = await useSanityQuery<Term>(getTermBySlug())

if (!data.value) {
  throw showError({
    status: 404,
    statusText: "Page not found",
  })
}

const termName = computed(() => data.value?.name)

useHead({
  templateParams: {
    term: name.value,
  },
  title: termName.value,
  titleTemplate: "%s | %term %separator %siteName",
})
</script>
